export default __webpack_public_path__ + "static/media/Learn More.40e10ce5.svg";